module.exports = __webpack_public_path__ + "img/sikringstiltak.ae3a9f9b.jpg";